import { useNavigate } from "react-router-dom";
import { useUIStore } from "@app/store";

/**
 * 500 Internal Server Error Page
 *
 * Displays when a server error occurs
 */
export function InternalServerErrorPage() {
  const navigate = useNavigate();
  const { clearError, error } = useUIStore();

  const handleGoHome = () => {
    clearError();
    navigate("/home");
  };

  const handleGoBack = () => {
    clearError();
    navigate(-1);
  };

  const handleRetry = () => {
    clearError();
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-4xl font-bold mb-4">500</h1>
        <p className="text-lg mb-2">Internal Server Error</p>
        <p className="text-sm text-muted-foreground mb-6">
          {error?.message ||
            "Something went wrong on our end. Please try again later."}
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="px-6 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleRetry}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Retry
          </button>
          <button
            onClick={handleGoHome}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
